import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import router from './router'
import store from './store';
import { config } from './config';

import './assets/scss/index.css'
import './assets/scss/font.scss'
import './assets/scss/reset.scss'
import './assets/scss/environment-switcher.scss'

Vue.config.productionTip = false
Vue.use(ElementUI);

new Vue({
  store,
  router,
  render: h => h(App),
  created() {
    // 设置页面标题
    document.title = config.title;
    
    // 如果用户已经登录，尝试获取用户信息
    if (localStorage.getItem('token')) {
      this.$store.dispatch('fetchUserInfo');
    }
  },
}).$mount('#app');